import React, { useRef } from 'react';

import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ title }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);
  return (
    <section
      ref={intersectionRef}
      className={classNames(
        'page-big-text p2 pt10--lg pb10--lg bb--dark-brown reveal',
        { revealed: isIntersected }
      )}
    >
      <h1 className="sans--md sans--lg--md sans--xl--lg">{title}</h1>
    </section>
  );
};
